import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { BillingInvoicesRoute } from '~/lib/helper/RouteHelper';

type UnpaidInvoiceBlockProps = {
    unpaidCount: number;
};

export default class UnpaidInvoiceBlock extends React.Component<UnpaidInvoiceBlockProps> {
    render() {
        return (
            <Card>
                <CardBody>
                    <h5>
                        {this.props.unpaidCount === 1
                            ? `You have an unpaid invoice`
                            : `You have ${this.props.unpaidCount} unpaid invoices`}
                    </h5>
                    <p>
                        We are unable to allocate more resources while there are outstanding invoices. Please visit the{' '}
                        <a href={BillingInvoicesRoute}>invoice page</a> to pay any outstanding invoices
                    </p>
                </CardBody>
            </Card>
        );
    }
}
